export default __webpack_public_path__ + "3bd478da82e4d1c686309a57de7f4dc9.png";